import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";
import dayjs from "dayjs";
import {
  YOUTUBE_CSV_COLUMNS,
  YoutubeCsvColumnKey,
} from "./csvColumns";

function escapeCsvValue(value: string | number | undefined): string {
  const text = String(value ?? "");
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function exportYoutubeSearchCsv(
  items: IYoutubeScrapeResponseItem[],
  columnKeys: YoutubeCsvColumnKey[]
): void {
  const selectedColumns = YOUTUBE_CSV_COLUMNS.filter((column) =>
    columnKeys.includes(column.key)
  );

  if (items.length === 0 || selectedColumns.length === 0) {
    return;
  }

  const headerRow = selectedColumns.map((column) => column.label).join(",");
  const dataRows = items.map((item) =>
    selectedColumns
      .map((column) => escapeCsvValue(column.getValue(item)))
      .join(",")
  );
  const csv = [headerRow, ...dataRows].join("\n");
  const blob = new Blob([`\uFEFF${csv}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `youtube-search-results-${dayjs().format("YYYY-MM-DD")}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
